import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ExclamationThickIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <path d='M10 3h4l-1 11h-2L10 3m4 16a2 2 0 1 1-3.999.001A2 2 0 0 1 14 19z'/>
    </svg>
));
